export default "__VITE_ASSET__DV9P9tbW__"